/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Combo_Recipe_Pick_Qty_PlaceholderInputs */

const vi_combo_recipe_pick_qty_placeholder = /** @type {(inputs: Combo_Recipe_Pick_Qty_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vd 5`)
};

/**

* @param {Combo_Recipe_Pick_Qty_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const combo_recipe_pick_qty_placeholder = /** @type {((inputs?: Combo_Recipe_Pick_Qty_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Combo_Recipe_Pick_Qty_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_combo_recipe_pick_qty_placeholder(inputs)
});